import React, { Fragment, useState, useEffect, useRef } from "react";
import Layout from "../../components/Layout/Layout";
import { Dialog, Transition } from "@headlessui/react";
import ActionDropdown from "../../components/ActionDropdown";
import TenantServices from "./../../services/TenantServices";
import fire from "./../../utils/Toastr";
import { PlusCircleIcon } from "@heroicons/react/outline";
import Paginate from "../../utils/Paginate";

export default function Tenant() {
  const tenant = sessionStorage.getItem("tenantId");

  const data = {
    tenantId: tenant,
    organizationName: "",
    officeAddress: "",
    contactName: "",
    contactEmailAddress: "",
    contactPhoneNumber: "",
    facebook: "",
    instagram: "",
    twitter: "",
    youtube: "",
    branchName: "",
    branchAddress: "",
    branchFormattedAddress: "",
    branchCode: "",
    latitude: "",
    longitude: "",
    id: "",
    primaryMailingList: "",
    secondaryMailingList: "",
  };
  const [tenants, setTenanat] = useState("");
  const [org, setOrg] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const itemsPerPage = 10;
  const totalCount = org.length;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const startIndex = (pageIndex - 1) * itemsPerPage;
  const displayedBranches = org.slice(startIndex, startIndex + itemsPerPage);
  const branchs = {
    branchName: "",
    branchAddress: "",
    branchFormattedAddress: "",
    latitude: "",
    longitude: "",
    branchCode: "",
    primaryMailingList: "",
    secondaryMailingList: "",
  };
  const [branchForm, setBranchForm] = useState(branchs);
  const [formValues, setFormValues] = useState(data);
  const [open, setOpen] = useState(false);
  const [openBranch, setOpenBranch] = useState(false);
  const [openOrg, setOpenOrg] = useState(false);
  const cancelButtonRef = useRef(null);

  const list = async () => {
    const resp = await TenantServices.listTenanat(tenant);
    setTenanat(resp.data);
    setOrg([...resp.data.organizationBranches]);
    setPageIndex(1);
  };

  const handleBranchUpdate = async (text) => {
    setOpenBranch(true);
    setFormValues({
      id: text.id,
      branchName: text.branchName,
      branchAddress: text.branchAddress,
      branchFormattedAddress: text.branchFormattedAddress,
      latitude: text.latitude,
      longitude: text.longitude,
      branchCode: text.branchCode,
      primaryMailingList: text.primaryMailingList || "",
      secondaryMailingList: text.secondaryMailingList || "",
    });
  };
  const handleUpdate = async (text) => {
    setOpenOrg(true);
    setFormValues({
      organizationName: text.organizationName,
      officeAddress: text.officeAddress,
      contactName: text.contactName,
      contactEmailAddress: text.contactEmailAddress,
      contactPhoneNumber: text.contactPhoneNumber,
      facebook: text.facebook,
      instagram: text.instagram,
      twitter: text.twitter,
      youtube: text.youtube,
    });
  };
  const createBranch = async () => {
    setOpen(true);
  };
  const handleClose = async () => {
    setOpen(false);
  };
  const update = async (e) => {
    e.preventDefault();
    const resp = await TenantServices.updateTenant({
      tenantId: tenant,
      organizationName: formValues.organizationName,
      officeAddress: formValues.officeAddress,
      contactName: formValues.contactName,
      contactEmailAddress: formValues.contactEmailAddress,
      contactPhoneNumber: formValues.contactPhoneNumber,
      facebook: formValues.facebook,
      instagram: formValues.instagram,
      twitter: formValues.twitter,
      youtube: formValues.youtube,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setOpen(false);
      }, 2000);
      window.location.reload();
    }
  };
  const updateBranch = async (e) => {
    e.preventDefault();
    const resp = await TenantServices.updateBranch({
      id: formValues.id,
      branchName: formValues.branchName,
      branchAddress: formValues.branchAddress,
      branchFormattedAddress: formValues.branchFormattedAddress,
      latitude: formValues.latitude,
      longitude: formValues.longitude,
      branchCode: formValues.branchCode,
      primaryMailingList: formValues.primaryMailingList,
      secondaryMailingList: formValues.secondaryMailingList,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        setOpenBranch(false);
        window.location.reload();
      }, 3000);
    }
  };
  const addBranch = async (e) => {
    e.preventDefault();
    const create = await TenantServices.createBranch(branchForm);
    if (create) {
      fire("success", create.message);
      setTimeout(() => {
        setOpen(false);
        window.location.reload();
      }, 4000);
    }
  };
  const deleteBranch = async (id) => {
    const resp = await TenantServices.deleteBranch({ branchId: id });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };
  // comment validation
  const formHandler = {
    officeAddressHandler: (event) => {
      setFormValues({ ...formValues, officeAddress: event.target.value });
    },
    contactNameHandler: (event) => {
      setFormValues({ ...formValues, contactName: event.target.value });
    },
    contactEmailAddressHandler: (event) => {
      setFormValues({ ...formValues, contactEmailAddress: event.target.value });
    },
    contactPhoneNumberHandler: (event) => {
      setFormValues({ ...formValues, contactPhoneNumber: event.target.value });
    },
    facebookHandler: (event) => {
      setFormValues({ ...formValues, facebook: event.target.value });
    },
    twitterHandler: (event) => {
      setFormValues({ ...formValues, twitter: event.target.value });
    },
    instagramHandler: (event) => {
      setFormValues({ ...formValues, instagram: event.target.value });
    },
    youtubeHandler: (event) => {
      setFormValues({ ...formValues, youtube: event.target.value });
    },
    latitudeHandler: (event) => {
      setFormValues({ ...formValues, latitude: event.target.value });
    },
    branchNameHandler: (event) => {
      setFormValues({ ...formValues, branchName: event.target.value });
    },
    longitudeHandler: (event) => {
      setFormValues({ ...formValues, longitude: event.target.value });
    },
    branchAddressHandler: (event) => {
      setFormValues({ ...formValues, branchAddress: event.target.value });
    },
    branchCodeHandler: (event) => {
      setFormValues({ ...formValues, branchCode: event.target.value });
    },
    branchFormatedAddressHandler: (event) => {
      setFormValues({
        ...formValues,
        branchFormattedAddress: event.target.value,
      });
    },
    primaryMailingListHandler: (event) => {
      setFormValues({
        ...formValues,
        primaryMailingList: event.target.value,
      });
    },
    secondaryMailingListHandler: (event) => {
      setFormValues({
        ...formValues,
        secondaryMailingList: event.target.value,
      });
    },
    orgBranchName: (event) => {
      setBranchForm({ ...branchForm, branchName: event.target.value });
    },
    orgBarnchAddress: (event) => {
      setBranchForm({ ...branchForm, branchAddress: event.target.value });
    },
    orgFormattedAddress: (event) => {
      setBranchForm({
        ...branchForm,
        branchFormattedAddress: event.target.value,
      });
    },
    orgLatitude: (event) => {
      setBranchForm({ ...branchForm, latitude: event.target.value });
    },
    orgLongitude: (event) => {
      setBranchForm({ ...branchForm, longitude: event.target.value });
    },
    orgBranchCodeHandler: (event) => {
      setBranchForm({ ...branchForm, branchCode: event.target.value });
    },
    orgPrimaryMailingList: (event) => {
      setBranchForm({ ...branchForm, primaryMailingList: event.target.value });
    },
    orgSecondaryMailingList: (event) => {
      setBranchForm({
        ...branchForm,
        secondaryMailingList: event.target.value,
      });
    },
  };
  useEffect(() => {
    list();
  }, []);
  return (
    <>
      <Layout
        pageTag={"tenure"}
        current={"/organisation"}
        title={"Organization"}
      >
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto ">
              <div className="">
                <div className="-my-2  overflow-x-auto ">
                  <div className="">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-16 bg-zinc-200">
                        <form>
                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <div className="px-6">
                                <h4>ORGANIZATION DETAILS</h4>
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Organization Name
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.organizationName === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.organizationName
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Office Address
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.officeAddress === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.officeAddress
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Contact Name
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.contactName === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.contactName
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="first-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Contact Email Address
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.contactEmailAddress ===
                                        null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.contactEmailAddress
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Contact Phone number
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.contactPhoneNumber === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.contactPhoneNumber
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Facebook Handle
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.facebook === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.facebook
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Instagram Handle
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.instagram === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.instagram
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Twitter Handle
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.twitter === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.twitter
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="last-name"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Youtube Handle
                                    </label>
                                    <div className="mt-1">
                                      <div className="org-form shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        {tenants.youtube === null ? (
                                          <p className="pt-4 pb-2"></p>
                                        ) : (
                                          tenants.youtube
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-end">
                                <button
                                  type="button"
                                  onClick={() => handleUpdate(tenants)}
                                  className="bg-black  align-center flex justify-center items-center rounded-md border px-8 py-2 text-sm font-medium text-white mr-4 shadow-sm  sm:w-auto"
                                >
                                  Edit
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between mt-8 p-3">
                    <h2 className="text-gray-900 font-semibold">
                      Organization Branches
                    </h2>
                    <div>
                      <button
                        type="button"
                        onClick={() => createBranch()}
                        className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                      >
                        <PlusCircleIcon className="w-4 mr-1.5" />
                        Add Branch
                      </button>
                    </div>
                  </div>

                  <div className="inline-block min-w-full py-2 align-middle mb-4 mt-8 overflow-x-auto">
                    <div className="relative pr-3 ring-black ring-opacity-5 md:rounded-lg">
                      <table className="min-w-full table-fixed divide-y divide-gray-300">
                        <thead className="bg-black">
                          <tr>
                            {[
                              "Branch Name",
                              "Branch Address",
                              "Branch Code",
                              "Primary Mailing List",
                              "Secondary Mailing List",
                              "Location",
                              "Action",
                            ].map((heading, idx) => (
                              <th
                                key={idx}
                                scope="col"
                                className="min-w-[8rem] max-w-[12rem] overflow-hidden text-ellipsis whitespace-nowrap py-3.5 pl-6 italic font-normal text-left text-sm text-white"
                              >
                                {heading}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                          {displayedBranches.map((person, i) => (
                            <tr className="bg-gray-50" key={i}>
                              <td className="whitespace-nowrap max-w-[12rem] truncate px-3 pl-6 py-4 text-sm text-gray-900">
                                {person.branchName}
                              </td>
                              <td className="whitespace-nowrap max-w-[12rem] truncate px-3 py-4 text-sm text-gray-900">
                                {person.branchAddress}
                              </td>
                              <td className="whitespace-nowrap max-w-[10rem] truncate px-3 py-4 text-sm text-gray-900">
                                {person.branchCode}
                              </td>
                              <td className="whitespace-nowrap max-w-[12rem] truncate px-3 py-4 text-sm text-gray-900">
                                {person.primaryMailingList}
                              </td>
                              <td className="whitespace-nowrap max-w-[12rem] truncate px-3 py-4 text-sm text-gray-900">
                                {person.secondaryMailingList}
                              </td>
                              <td className="whitespace-nowrap max-w-[10rem] px-3 py-4 text-sm text-gray-900">
                                {person.branchFormattedAddress ? (
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_MAP}${person.branchFormattedAddress}`}
                                    className="inline-flex bg-green-400 items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm hover:text-white active:text-white"
                                  >
                                    View
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                <ActionDropdown
                                  items={[
                                    { label: "Update Branch", onClick: () => handleBranchUpdate(person) },
                                    { label: "Delete Branch", onClick: () => deleteBranch(person.id) },
                                  ]}
                                  dropdownWidth="w-40"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <Paginate
                    nextPage={pageIndex < totalPages}
                    pageIndex={pageIndex}
                    totalCount={totalCount}
                    totalPages={totalPages}
                    prevPage={pageIndex > 1}
                    setPageIndex={setPageIndex}
                  />
                </div>
              </div>
            </div>
          </main>
          {/* Approve modal */}
          <Transition.Root show={openOrg} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="contactName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Contact Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="contactName"
                                    name="contactName"
                                    type="text"
                                    value={formValues.contactName}
                                    onChange={formHandler.contactNameHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="contactPhoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Contact PhoneNumber
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="contactPhoneNumber"
                                    name="contactPhoneNumber"
                                    type="text"
                                    value={formValues.contactPhoneNumber}
                                    onChange={
                                      formHandler.contactPhoneNumberHandler
                                    }
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="contactEmailAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Contact Email Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="contactEmailAddress"
                                    name="contactEmailAddress"
                                    type="email"
                                    value={formValues.contactEmailAddress}
                                    onChange={
                                      formHandler.contactEmailAddressHandler
                                    }
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="officeAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Office Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="officeAddress"
                                    name="officeAddress"
                                    type="text"
                                    value={formValues.officeAddress}
                                    onChange={formHandler.officeAddressHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="facebook"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Facebook
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="facebook"
                                    name="facebook"
                                    type="text"
                                    value={formValues.facebook}
                                    onChange={formHandler.facebookHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="instagram"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Instagram
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="instagram"
                                    name="instagram"
                                    type="text"
                                    value={formValues.instagram}
                                    onChange={formHandler.instagramHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="twitter"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Twitter
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="twitter"
                                    name="twitter"
                                    type="text"
                                    value={formValues.twitter}
                                    onChange={formHandler.twitterHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="youtube"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Youtube
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="youtube"
                                    name="youtube"
                                    type="text"
                                    value={formValues.youtube}
                                    onChange={formHandler.youtubeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                <button
                                  type="button"
                                  className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                                  onClick={update}
                                >
                                  Update
                                </button>
                                <button
                                  type="button"
                                  className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                                  onClick={() => setOpenOrg(false)}
                                  ref={cancelButtonRef}
                                >
                                  Cancel
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>

          {/* Create modal */}
          <Transition.Root show={open} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="text-3xl">Create Branch</div>
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="orgBranchName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="orgBranchName"
                                    name="orgBranchName"
                                    type="text"
                                    placeholder="Enter branch name"
                                    value={branchForm.branchName}
                                    onChange={formHandler.orgBranchName}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="orgBarnchAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="orgBarnchAddress"
                                    name="orgBarnchAddress"
                                    type="text"
                                    placeholder="Enter branch address"
                                    value={branchForm.branchAddress}
                                    onChange={formHandler.orgBarnchAddress}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="orgFormattedAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Formatted Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="orgFormattedAddress"
                                    name="orgFormattedAddress"
                                    type="text"
                                    placeholder="Enter branch formatted address"
                                    value={branchForm.branchFormattedAddress}
                                    onChange={formHandler.orgFormattedAddress}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="orgLongitude"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Longitude
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="orgLongitude"
                                    name="orgLongitude"
                                    type="text"
                                    placeholder="Enter branch longitude"
                                    value={branchForm.longitude}
                                    onChange={formHandler.orgLongitude}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="orgLatitude"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Latitude
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="orgLatitude"
                                    name="orgLatitude"
                                    type="text"
                                    placeholder="Enter branch latitude"
                                    value={branchForm.latitude}
                                    onChange={formHandler.orgLatitude}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>

                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchCode"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Code
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="branchCode"
                                    name="branchCode"
                                    type="text"
                                    placeholder="Enter branch code"
                                    value={branchForm.branchCode}
                                    onChange={formHandler.orgBranchCodeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>

                              <div className="sm:col-span-6">
                                <label
                                  htmlFor="primaryMailingList"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Primary Mailing List (comma separated emails)
                                </label>
                                <div className="mt-1">
                                  <textarea
                                    id="primaryMailingList"
                                    name="primaryMailingList"
                                    rows={3}
                                    placeholder="Enter comma separated emails"
                                    value={branchForm.primaryMailingList}
                                    onChange={formHandler.orgPrimaryMailingList}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>

                              <div className="sm:col-span-6">
                                <label
                                  htmlFor="secondaryMailingList"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Secondary Mailing List (comma separated
                                  emails)
                                </label>
                                <div className="mt-1">
                                  <textarea
                                    id="secondaryMailingList"
                                    name="secondaryMailingList"
                                    rows={3}
                                    placeholder="Enter comma separated emails"
                                    value={branchForm.secondaryMailingList}
                                    onChange={
                                      formHandler.orgSecondaryMailingList
                                    }
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                              onClick={addBranch}
                            >
                              Add
                            </button>
                            <button
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                              onClick={() => setOpen(false)}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
          {/* Update branch */}
          <Transition.Root show={openBranch} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              initialFocus={cancelButtonRef}
              onClose={handleClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed z-10 inset-0 overflow-y-auto">
                <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-6/12 sm:p-6">
                      <div>
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="text-3xl">Update Branch</div>
                          <div className="mt-2">
                            <form className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="contactName"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Name
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="branchName"
                                    name="branchName"
                                    type="text"
                                    placeholder="Enter branch name"
                                    value={formValues.branchName}
                                    onChange={formHandler.branchNameHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="contactPhoneNumber"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="contactPhoneNumber"
                                    name="contactPhoneNumber"
                                    type="text"
                                    placeholder="Enter branch address"
                                    value={formValues.branchAddress}
                                    onChange={formHandler.branchAddressHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="contactEmailAddress"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Formatted Address
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="contactEmailAddress"
                                    name="contactEmailAddress"
                                    type="email"
                                    placeholder="Enter branch formatted address"
                                    value={formValues.branchFormattedAddress}
                                    onChange={
                                      formHandler.branchFormatedAddressHandler
                                    }
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="longitude"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Longitude
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="longitude"
                                    name="longitude"
                                    type="text"
                                    placeholder="Enter branch longitude"
                                    value={formValues.longitude}
                                    onChange={formHandler.longitudeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="latitude"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Latitude
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="latitude"
                                    name="latitude"
                                    type="text"
                                    placeholder="Enter branch latitude"
                                    value={formValues.latitude}
                                    onChange={formHandler.latitudeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="branchCode"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Branch Code
                                </label>
                                <div className="mt-1">
                                  <input
                                    id="branchCode"
                                    name="branchCode"
                                    type="text"
                                    placeholder="Enter branch code"
                                    value={formValues.branchCode}
                                    onChange={formHandler.branchCodeHandler}
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>

                              <div className="sm:col-span-6">
                                <label
                                  htmlFor="primaryMailingList"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Primary Mailing List (comma separated emails)
                                </label>
                                <div className="mt-1">
                                  <textarea
                                    id="primaryMailingList"
                                    name="primaryMailingList"
                                    rows={3}
                                    placeholder="Enter comma separated emails"
                                    value={formValues.primaryMailingList}
                                    onChange={
                                      formHandler.primaryMailingListHandler
                                    }
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>

                              <div className="sm:col-span-6">
                                <label
                                  htmlFor="secondaryMailingList"
                                  className="text-left mt-2 block text-sm font-medium text-gray-700"
                                >
                                  Secondary Mailing List (comma separated
                                  emails)
                                </label>
                                <div className="mt-1">
                                  <textarea
                                    id="secondaryMailingList"
                                    name="secondaryMailingList"
                                    rows={3}
                                    placeholder="Enter comma separated emails"
                                    value={formValues.secondaryMailingList}
                                    onChange={
                                      formHandler.secondaryMailingListHandler
                                    }
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                            <button
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                              onClick={updateBranch}
                            >
                              Update
                            </button>
                            <button
                              type="button"
                              className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                              onClick={() => setOpenBranch(false)}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </React.Fragment>
      </Layout>
    </>
  );
}
